import AttachmentDAO from "./AttachmentDAO";
import CachingAttachmentContentDAOFactory from "./content/cache/CachingAttachmentContentDAOFactory";
import ClientLoggerFactory from "../logging/ClientLoggerFactory";
import DataStoreAttachmentRecordDAOFactory from "./record/datastore/DataStoreAttachmentRecordDAOFactory";
import { attachmentUploadQueue } from "./upload/manager/AttachmentUploadQueueFactory";

export default class AttachmentDAOFactory {
    private static readonly INSTANCE = new AttachmentDAO(
        ClientLoggerFactory.getClientLogger("AttachmentDAO"),
        CachingAttachmentContentDAOFactory.getInstance(),
        DataStoreAttachmentRecordDAOFactory.getInstance(),
        attachmentUploadQueue
    );
    
    static getAttachmentDAO() {
        return this.INSTANCE;
    }
}